// Curated icon set for service categories, drawn from multiple Iconify
// libraries to maximise visual variety. Render via:
//   <Icon icon={CATEGORY_ICON_MAP[icon]} />
// `key` is the value persisted on the category model.
export const CATEGORY_ICONS = [
  // Teeth & orthodontics
  { key: "tooth",            label: "Tooth (solid)",    icon: "mdi:tooth" },
  { key: "tooth-outline",    label: "Tooth (outline)",  icon: "mdi:tooth-outline" },
  { key: "teeth",            label: "Teeth",            icon: "game-icons:teeth" },
  { key: "tooth-broken",     label: "Broken tooth",     icon: "healthicons:dental-tooth-broken" },
  { key: "tooth-implant",    label: "Implant",          icon: "healthicons:dental-implant" },
  { key: "braces",           label: "Braces",           icon: "game-icons:dental-crown" },
  { key: "molar",            label: "Molar",            icon: "game-icons:molar" },

  // Cosmetic / whitening
  { key: "sparkle",          label: "Sparkle",          icon: "mdi:auto-awesome" },
  { key: "magic-wand",       label: "Wand",             icon: "ph:magic-wand-bold" },
  { key: "shine",            label: "Shine",            icon: "tabler:sparkles" },
  { key: "smile",            label: "Smile",            icon: "ph:smiley-bold" },
  { key: "diamond",          label: "Diamond",          icon: "ph:diamond-bold" },

  // Clinic / general
  { key: "stethoscope",      label: "Stethoscope",      icon: "tabler:stethoscope" },
  { key: "dentist-chair",    label: "Dentist chair",    icon: "healthicons:dental-checkup" },
  { key: "first-aid",        label: "First aid",        icon: "ph:first-aid-kit-bold" },
  { key: "syringe",          label: "Syringe",          icon: "tabler:vaccine" },
  { key: "scan",             label: "X-ray / Scan",     icon: "tabler:scan" },
  { key: "doctor",           label: "Doctor",           icon: "healthicons:doctor-male" },
  { key: "shield-check",     label: "Protection",       icon: "tabler:shield-check" },

  // Kids
  { key: "baby",             label: "Baby",             icon: "ph:baby-bold" },
  { key: "child",            label: "Child",            icon: "tabler:mood-kid" },
  { key: "balloon",          label: "Balloon",          icon: "tabler:balloon" },
  { key: "star",             label: "Star",             icon: "ph:star-bold" },
  { key: "heart",            label: "Heart",            icon: "ph:heart-bold" },

  // Emergency / specialised
  { key: "bolt",             label: "Emergency",        icon: "tabler:bolt" },
  { key: "fire",             label: "Hot offer",        icon: "ph:fire-bold" },
];

export const DEFAULT_CATEGORY_ICON = "tooth";

export const CATEGORY_ICON_MAP = Object.fromEntries(
  CATEGORY_ICONS.map((o) => [o.key, o.icon])
);

// Resolve a stored key (or null/undefined) to a renderable iconify name.
export function resolveCategoryIcon(key) {
  return CATEGORY_ICON_MAP[key] || CATEGORY_ICON_MAP[DEFAULT_CATEGORY_ICON];
}
